import { BrowserRouter as Router, Routes, Route, useParams, Navigate } from 'react-router-dom';
import { Layout } from 'antd';
import CourseSelection from './components/CourseSelection';
import CourseContent from './components/CourseContent';
import Login from './components/Login';
import Register from './components/Register';
import TopNavBar from './components/TopNavBar';
import UserDashboard from './components/UserDashboard';
import UserSettings from './components/UserSettings';
import LearningHistory from './components/LearningHistory';
import DebugPanel from './components/DebugPanel';

const { Content } = Layout;

const CourseContentWithId = () => {
    const { id } = useParams();
    return <CourseContent id={id} />;
};

const App = () => (
    <Router>
        <Layout style={{ minHeight: '100vh' }}>
            <TopNavBar />
            <Content>
                <Routes>
                    <Route path="/" element={<Navigate to="/course-selection" />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/course-selection" element={<CourseSelection />} />
                    <Route path="/course/:id" element={<CourseContentWithId />} />
                    <Route path="/dashboard" element={<UserDashboard />} />
                    <Route path="/settings" element={<UserSettings />} />
                    <Route path="/history" element={<LearningHistory />} />
                </Routes>
            </Content>
            {/* 只在开发环境显示调试面板 */}
            {process.env.NODE_ENV === 'development' && <DebugPanel />}
        </Layout>
    </Router>
);

export default App;
